class ShellError extends Error {}

export class AccessDeniedError extends ShellError {}
export class NotFoundError extends ShellError {}
